import { render, staticRenderFns } from "./BaseTabControlHeaders.vue?vue&type=template&id=4bc7f361&scoped=true&"
import script from "./BaseTabControlHeaders.vue?vue&type=script&lang=js&"
export * from "./BaseTabControlHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7f361",
  null
  
)

export default component.exports